import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/whatsapp";

export const PageHero = ({ label, heading, text, testIdPrefix }) => (
  <section className="mx-auto max-w-6xl px-5 sm:px-8">
    <div className="py-14 sm:py-20">
      <div className="reveal flex items-center gap-4" data-testid={`${testIdPrefix}-eyebrow`}>
        <span className="h-px w-10 bg-[#c9a24b]" />
        <p className="section-label">{label}</p>
      </div>
      <h1
        data-testid={`${testIdPrefix}-heading`}
        className="font-display reveal mt-7 max-w-2xl text-3xl leading-[1.2] text-[#f2ede3] sm:text-4xl lg:text-5xl"
        style={{ animationDelay: "0.1s" }}
      >
        {heading}
      </h1>
      {text && (
        <p
          data-testid={`${testIdPrefix}-subheading`}
          className="reveal mt-6 max-w-xl text-sm leading-relaxed text-[#a09a8c] sm:text-base"
          style={{ animationDelay: "0.2s" }}
        >
          {text}
        </p>
      )}
    </div>
  </section>
);

export const WhatsAppCta = ({ heading, text, testIdPrefix }) => (
  <section className="border-t border-[rgba(201,162,75,0.22)] bg-[#111110]">
    <div className="mx-auto max-w-6xl px-5 py-12 text-center sm:px-8 sm:py-14">
      <div className="mx-auto h-px w-12 bg-[#c9a24b]" />
      <h2
        data-testid={`${testIdPrefix}-cta-heading`}
        className="font-display mx-auto mt-5 max-w-2xl text-2xl text-[#f2ede3] sm:text-3xl"
      >
        {heading}
      </h2>
      <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-[#a09a8c]">
        {text}
      </p>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${testIdPrefix}-cta-whatsapp-button`}
        className="mt-7 inline-flex items-center gap-2 bg-[#c9a24b] px-8 py-3.5 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-[#0a0a09] transition-colors duration-200 hover:bg-[#e6c87a]"
      >
        <MessageCircle size={15} />
        Chat on WhatsApp
      </a>
    </div>
  </section>
);
